import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d27e354"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 bg-light p-3" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Driver Detail", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row height d-flex justify-content-center align-items-center" })
], -1))
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Driver Id", -1))
const _hoisted_10 = { class: "col-sm-3 text-end" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Name", -1))
const _hoisted_12 = { class: "col-sm-3 text-end" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Email", -1))
const _hoisted_15 = { class: "col-sm-3 text-end" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Phone", -1))
const _hoisted_17 = { class: "col-sm-3 text-end" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Device Type", -1))
const _hoisted_20 = { class: "col-sm-3 text-end" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Available", -1))
const _hoisted_22 = { class: "col-sm-3 text-end" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "IS Buzy", -1))
const _hoisted_25 = { class: "col-sm-3 text-end" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Wallet Amount", -1))
const _hoisted_27 = { class: "col-sm-3 text-end" }
const _hoisted_28 = { class: "row row-striped" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "IS Block", -1))
const _hoisted_30 = { class: "col-sm-3 text-end" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Vehicle type", -1))
const _hoisted_32 = { class: "col-sm-3 text-end" }
const _hoisted_33 = { class: "row row-striped" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Country", -1))
const _hoisted_35 = { class: "col-sm-3 text-end" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "City", -1))
const _hoisted_37 = { class: "col-sm-3 text-end" }
const _hoisted_38 = { class: "row row-striped" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "DOB", -1))
const _hoisted_40 = { class: "col-sm-3 text-end" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Registration No", -1))
const _hoisted_42 = { class: "col-sm-3 text-end" }
const _hoisted_43 = { class: "row row-striped" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Socket Id", -1))
const _hoisted_45 = { class: "col-sm-3 text-end" }
const _hoisted_46 = ["value"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "FCM Push Tokn", -1))
const _hoisted_48 = { class: "col-sm-3 text-end" }
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "row row-striped" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Latitude", -1))
const _hoisted_52 = { class: "col-sm-3 text-end" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Longitude", -1))
const _hoisted_54 = { class: "col-sm-3 text-end" }
const _hoisted_55 = { class: "row row-striped" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Created", -1))
const _hoisted_57 = { class: "col-sm-3 text-end" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Last Updated", -1))
const _hoisted_59 = { class: "col-sm-3 text-end" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "bank account title", -1))
const _hoisted_62 = { class: "col-sm-3 text-end" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "bank account number", -1))
const _hoisted_64 = { class: "col-sm-3 text-end" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "bank sort code", -1))
const _hoisted_67 = { class: "col-sm-3 text-end" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Other Bank detail", -1))
const _hoisted_69 = { class: "col-sm-3 text-end" }
const _hoisted_70 = { class: "row row-striped" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Post Code", -1))
const _hoisted_72 = { class: "col-sm-3 text-end" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Address", -1))
const _hoisted_74 = { class: "col-sm-3 text-end" }
const _hoisted_75 = ["src"]
const _hoisted_76 = { class: "row" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Device Name", -1))
const _hoisted_78 = { class: "col-sm-3 text-end" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Device Model", -1))
const _hoisted_80 = { class: "col-sm-3 text-end" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "App Version", -1))
const _hoisted_83 = { class: "col-sm-3 text-end" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "App Version Code", -1))
const _hoisted_85 = { class: "col-sm-3 text-end" }
const _hoisted_86 = { class: "row" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Device Info", -1))
const _hoisted_88 = { class: "col-sm-3 text-end" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Device Unique Id", -1))
const _hoisted_90 = { class: "col-sm-3 text-end" }
const _hoisted_91 = { class: "row" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Facebook Id", -1))
const _hoisted_93 = { class: "col-sm-3 text-end" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Gmail Id", -1))
const _hoisted_95 = { class: "col-sm-3 text-end" }
const _hoisted_96 = { class: "row" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Apple Id", -1))
const _hoisted_98 = { class: "col-sm-3 text-end" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Socket Id", -1))
const _hoisted_100 = { class: "col-sm-3 text-end" }
const _hoisted_101 = { class: "row" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Login Type", -1))
const _hoisted_103 = { class: "col-sm-3 text-end" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Registration Type", -1))
const _hoisted_105 = { class: "col-sm-3 text-end" }
const _hoisted_106 = { class: "row" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Profile Pic", -1))
const _hoisted_108 = { class: "col-sm-9 text-end" }
const _hoisted_109 = ["src"]
const _hoisted_110 = { class: "row" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Driving License", -1))
const _hoisted_112 = { class: "col-sm-9 text-end" }
const _hoisted_113 = ["src"]
const _hoisted_114 = { class: "row" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Driving Insurance", -1))
const _hoisted_116 = { class: "col-sm-9 text-end" }
const _hoisted_117 = ["src"]
const _hoisted_118 = { class: "row" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Work Proof", -1))
const _hoisted_120 = { class: "col-sm-9 text-end" }
const _hoisted_121 = ["src"]
const _hoisted_122 = { class: "row" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "CNIC", -1))
const _hoisted_124 = { class: "col-sm-9 text-end" }
const _hoisted_125 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_router_link, {
            to: `/tracking/driver/${$setup.rider.id}/location`,
            class: "btn btn-sm btn-primary align-self-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Live Location")
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString($setup.rider.id), 1),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString($setup.rider.rider_name), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, _toDisplayString($setup.rider.rider_email), 1),
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, _toDisplayString($setup.rider.rider_phone), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, _toDisplayString($setup.rider.device_type), 1),
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, _toDisplayString($setup.rider.availability_status), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, _toDisplayString($setup.rider.is_buzy), 1),
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, _toDisplayString($setup.rider.country?.currency_short_name) + _toDisplayString($setup.rider.wallet_amount), 1)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, _toDisplayString($setup.rider.is_block), 1),
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, _toDisplayString($setup.rider.vehicle_type), 1)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, _toDisplayString($setup.rider.country?.name), 1),
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, _toDisplayString($setup.rider.city?.name), 1)
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, _toDisplayString($setup.rider.rider_dob), 1),
          _hoisted_41,
          _createElementVNode("div", _hoisted_42, _toDisplayString($setup.rider.rider_registration_no), 1)
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("textarea", {
              value: $setup.rider.socket_id
            }, null, 8, _hoisted_46)
          ]),
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("textarea", {
              value: $setup.rider.fcm_token
            }, null, 8, _hoisted_49)
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _hoisted_51,
          _createElementVNode("div", _hoisted_52, _toDisplayString($setup.rider.rider_lat), 1),
          _hoisted_53,
          _createElementVNode("div", _hoisted_54, _toDisplayString($setup.rider.rider_lan), 1)
        ]),
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, _toDisplayString($options.dateTime($setup.rider.created_at)), 1),
          _hoisted_58,
          _createElementVNode("div", _hoisted_59, _toDisplayString($options.dateTime($setup.rider.updated_at)), 1)
        ]),
        _createElementVNode("div", _hoisted_60, [
          _hoisted_61,
          _createElementVNode("div", _hoisted_62, _toDisplayString($setup.rider.bank_account_title), 1),
          _hoisted_63,
          _createElementVNode("div", _hoisted_64, _toDisplayString($setup.rider.bank_account_number), 1)
        ]),
        _createElementVNode("div", _hoisted_65, [
          _hoisted_66,
          _createElementVNode("div", _hoisted_67, _toDisplayString($setup.rider.bank_sort_code), 1),
          _hoisted_68,
          _createElementVNode("div", _hoisted_69, _toDisplayString($setup.rider.bank_other_detail), 1)
        ]),
        _createElementVNode("div", _hoisted_70, [
          _hoisted_71,
          _createElementVNode("div", _hoisted_72, _toDisplayString($setup.rider.rider_postal_code), 1),
          _hoisted_73,
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("img", {
              src: $setup.rider.rider_address,
              width: "300"
            }, null, 8, _hoisted_75)
          ])
        ]),
        _createElementVNode("div", _hoisted_76, [
          _hoisted_77,
          _createElementVNode("div", _hoisted_78, _toDisplayString($setup.rider.device_name), 1),
          _hoisted_79,
          _createElementVNode("div", _hoisted_80, _toDisplayString($setup.rider.device_model), 1)
        ]),
        _createElementVNode("div", _hoisted_81, [
          _hoisted_82,
          _createElementVNode("div", _hoisted_83, _toDisplayString($setup.rider.app_version), 1),
          _hoisted_84,
          _createElementVNode("div", _hoisted_85, _toDisplayString($setup.rider.app_version_code), 1)
        ]),
        _createElementVNode("div", _hoisted_86, [
          _hoisted_87,
          _createElementVNode("div", _hoisted_88, _toDisplayString($setup.rider.device_info), 1),
          _hoisted_89,
          _createElementVNode("div", _hoisted_90, _toDisplayString($setup.rider.device_unique_id), 1)
        ]),
        _createElementVNode("div", _hoisted_91, [
          _hoisted_92,
          _createElementVNode("div", _hoisted_93, _toDisplayString($setup.rider.fb_id), 1),
          _hoisted_94,
          _createElementVNode("div", _hoisted_95, _toDisplayString($setup.rider.gmail_id), 1)
        ]),
        _createElementVNode("div", _hoisted_96, [
          _hoisted_97,
          _createElementVNode("div", _hoisted_98, _toDisplayString($setup.rider.apple_id), 1),
          _hoisted_99,
          _createElementVNode("div", _hoisted_100, _toDisplayString($setup.rider.socket_id), 1)
        ]),
        _createElementVNode("div", _hoisted_101, [
          _hoisted_102,
          _createElementVNode("div", _hoisted_103, _toDisplayString($setup.rider.login_type), 1),
          _hoisted_104,
          _createElementVNode("div", _hoisted_105, _toDisplayString($setup.rider.registration_type), 1)
        ]),
        _createElementVNode("div", _hoisted_106, [
          _hoisted_107,
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("img", {
              src: $setup.rider.rider_profile_img,
              width: "300"
            }, null, 8, _hoisted_109)
          ])
        ]),
        _createElementVNode("div", _hoisted_110, [
          _hoisted_111,
          _createElementVNode("div", _hoisted_112, [
            _createElementVNode("img", {
              src: $setup.rider.driving_license,
              width: "300"
            }, null, 8, _hoisted_113)
          ])
        ]),
        _createElementVNode("div", _hoisted_114, [
          _hoisted_115,
          _createElementVNode("div", _hoisted_116, [
            _createElementVNode("img", {
              src: $setup.rider.driving_insurance,
              width: "300"
            }, null, 8, _hoisted_117)
          ])
        ]),
        _createElementVNode("div", _hoisted_118, [
          _hoisted_119,
          _createElementVNode("div", _hoisted_120, [
            _createElementVNode("img", {
              src: $setup.rider.work_proof,
              width: "300"
            }, null, 8, _hoisted_121)
          ])
        ]),
        _createElementVNode("div", _hoisted_122, [
          _hoisted_123,
          _createElementVNode("div", _hoisted_124, [
            _createElementVNode("img", {
              src: $setup.rider.rider_cnic,
              width: "300"
            }, null, 8, _hoisted_125)
          ])
        ])
      ])
    ])
  ]))
}